import React from 'react'

const StoreInfo = ({review}) => { 
  return (
    <div className='d-flex gap-2'>
           <div className="avatar">
              {review?.store?.logo &&  <img
              style={{aspectRatio:"1"}}
                  src={review?.store?.logo}
                  alt=""
                  className="img-50 rounded-circle media"
                />}
              </div>
              <div>
                <div >
                  <h4 className='font19'>{review?.store?.name}</h4>
                     <div className='desc'>{review?.store?.categories}</div>
                </div>
              </div>
        
    </div>

  )
}

export default StoreInfo